const getMimeFromExt = (ext) => {
    let mimeType;
    switch (ext) {
        case "jpg":
            mimeType = "image/jpeg";
            break;
        case "jpeg":
            mimeType = "image/jpeg";
            break;
        case "gif":
            mimeType = "image/gif";
            break;
        case "png":
            mimeType = "image/png";
            break;
        case "webp":
            mimeType = "image/webp";
            break;
        case "mpeg":
            mimeType = "video/mpeg";
            break;
        case "mp4":
            mimeType = "video/mp4";
            break;
        case "mp3":
            mimeType = "audio/mpeg";
            break;

        default:
            break;
    }
    return mimeType;
};
export { getMimeFromExt };
